import React from 'react';
import Banner from './Banner';
import { IconCard } from './icons';

export default function BannerTarjeta() {
  return (
    <>
      <div className="options-subtitle">¿No tenés tarjeta Visa?</div>
      <Banner
        href="https://www.itau.com.uy/inst/tarjetas.html"
        text="Pedí tu tarjeta Visa online"
        icon={<IconCard />}
      />
    </>
  );
}
